import { createFileRoute } from "@tanstack/react-router";
import AutoImport from "@/pages/AutoImport";
import { PrivateRoute } from "@/components/shared/PrivateRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/auto-import/")({
  head: () => routeHead("/uk/auto-import/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateRoute><AutoImport /></PrivateRoute>
  );
}
